export default __webpack_public_path__ + "static/media/qr.aa6a504e.png";